<template>
  <h1>{{ resumo }}</h1>
  <h2>{{ edital }}</h2>
  <template v-if="area.length > 0">
    <h5>{{ $t("procedimento.UMA_LANG_DOCSBOLSA_AREA_CIENTIFICA") }}:</h5>
    <p>{{ area }}</p>
  </template>
  <h5>{{ $t("procedimento.UMA_LANG_DOCSBOLSA_PERFIL_PROCEDIMENTO") }}:</h5>
  <p v-html="desc"></p>
  <template v-if="localtrabalho.length > 0">
    <h5>{{ $t("procedimento.UMA_LANG_DOCSBOLSA_LOCAL") }}:</h5>
    <p>{{ localtrabalho }}</p>
  </template>
  <template v-if="duracao.length > 0">
    <h5>{{ $t("procedimento.UMA_LANG_DOCSBOLSA_DURACAO_PROCEDIMENTO") }}:</h5>
    <p>{{ duracao }}</p>
  </template>
</template>

<script>
export default {
  props: ["resumo","edital","area","descricao","localtrabalho","duracao"],
  setup(props) {

    const desc = props.descricao.replaceAll('\n', "<br/>");

    return {
      desc
    }
  }
}
</script>

<style lang="scss" scoped>
.bolsa_detalhe h5 {
  font-size: 12px;
  font-family: "Montserrat Semibold";
  text-transform: uppercase;
  color: #535d61;
  margin-bottom: 0px;
}

.bolsa_detalhe h1 {
  font-family: "Montserrat Bold";
  font-size: 24px;
  padding-bottom: 10px;
  margin-top: 50px;
  color: #535d61;
}

.bolsa_detalhe h2 {
  color: #6eb7ec;
  font-family: "Montserrat Bold";
  font-size: 20px;
  padding-bottom: 28px;
}

.bolsa_detalhe p {
  font-family: "Montserrat";
  font-size: 16px;
  margin-bottom: 30px;
  margin-top: 5px;
  font-family: 'PT Sans';
  color: #656565;
}

@media (min-width : 768px) and (max-width : 1024px) {
  .bolsa_detalhe h1 {
    font-size: 20px;
    margin-top: 35px;
  }

  .bolsa_detalhe h2 {
    font-size: 18px;
  }

  .bolsa_detalhe p {
    font-size: 15px;
    margin-bottom: 20px;
  }

}

@media screen and (max-width:767px) {
  .bolsa_detalhe h1 {
    font-size: 16px;
    margin-top: 10px;
    padding-top: 15px;
    margin-bottom: 0px;
    padding-bottom: 5px;
  }

  .bolsa_detalhe h2 {
    font-size: 16px;
    padding-top: 5px;
    padding-bottom: 20px;
  }

  .servico_bolsas_detalhe h5 {
    font-size: 12px;
  }

  .servico_bolsas_detalhe p {
    font-size: 14px;
    margin-bottom: 20px;
  }
}
</style>